import cx from 'classnames';
import styles from './PlanInfoActionCard.module.scss';
import { CONTENT_WRAPPER_TYPE, ContentWrapper } from './ContentWrapper';
import ActionLink from './ActionLink';
import ArrowDownIcon from '../../components/icons/ArrowDownIcon';
import { useEffect, useState } from 'react';

function PlanInfoActionCard({
  split = false,
  includeValue = null,
  includeLabel = null,
  firstLineIncludeValue = null,
  children,
  title = '',
  description = '',
  title2 = '',
  description2 = '',
  style = {
    alignSelf: 'stretch',
    left: 'unset',
    top: 'unset',
    width: 'unset',
  },
  titleStyle = {
    fontSize: '16px',
    letterSpacing: '0.32px',
    lineHeight: '20px',
  },
  cardTitleStyle = {},
  contentWrapperType = CONTENT_WRAPPER_TYPE.NORMAL,
  actionText = '',
  onClick = () => {},
  actionText2 = '',
  onClick2 = () => {},
  actionTextStyle = {
    left: 'unset',
    top: 'unset',
  },
  fullWidth = false,
  className = '',
  containerStyle = {},
  enableAccordion = false,
  keepOpen = false,
  isPermission,
}) {
  const [open, toggle] = useState(keepOpen);

  useEffect(() => {
    open !== keepOpen && toggle(keepOpen);
  }, [keepOpen]);

  const actionButton = (
    <ActionLink
      style={actionTextStyle}
      title={actionText}
      onClick={onClick}
      title2={actionText2}
      onClick2={onClick2}
    />
  );
  return (
    <article
      className={cx(styles.container, className)}
      style={
        fullWidth
          ? {
              width: '100%',
              flexBasis: '100%',
              ...containerStyle,
            }
          : { ...containerStyle }
      }>
      {split ? (
        <div className="d-flex gap-4 align-items-center">
          {title && description && (
            <div className={styles.info} style={{ width: 70, flex: 0 }}>
              <div className={styles.title} style={cardTitleStyle}>
                {title}
              </div>
              {description && (
                <ContentWrapper
                  style={style}
                  text={description}
                  titleStyle={titleStyle}
                  type={contentWrapperType}
                />
              )}
            </div>
          )}
          {title && description && title2 && description2 && <div className="px-2">Or</div>}
          {title2 && description2 && (
            <div className={styles.info} style={{ flex: 0 }}>
              <div className={styles.title} style={cardTitleStyle}>
                {title2}
              </div>
              {description2 && (
                <ContentWrapper
                  style={style}
                  text={description2}
                  titleStyle={titleStyle}
                  type={contentWrapperType}
                />
              )}
            </div>
          )}
        </div>
      ) : (
        <>
          <div
            className={styles.info}
            style={enableAccordion ? { cursor: 'pointer' } : {}}
            {...(enableAccordion ? { onClick: () => toggle(!open) } : {})}>
            <div className={styles.title} style={cardTitleStyle}>
              {title}
            </div>
            {(onClick || onClick2) && <>{actionButton}</>}
            {enableAccordion ? (
              <ArrowDownIcon style={open ? { transform: 'rotate(180deg)' } : {}} />
            ) : null}
          </div>
          {includeLabel ? (
            <h6
              className="m-0"
              style={{
                fontSize: 15,
                fontWeight: 600,
                letterSpacing: '0.25px',
                color: 'rgba(31, 31, 31, 0.5)',
              }}>
              {includeLabel}
            </h6>
          ) : null}
          {firstLineIncludeValue ? <p className="mb-0">{firstLineIncludeValue}</p> : null}
          {includeValue ? <p className="mb-0">{includeValue}</p> : null}
          {description && (
            <ContentWrapper
              style={style}
              text={description}
              titleStyle={titleStyle}
              type={contentWrapperType}
            />
          )}
          {enableAccordion ? (open ? children : null) : children}
        </>
      )}
    </article>
  );
}

export default PlanInfoActionCard;
